import {ProductWastageReportData} from "./product-wastage-report.data";
import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";

@Injectable()
export class ProductWastageReportModel extends ReportModel<ProductWastageReportData> {
    constructor(injector: Injector) {
        super(injector, ProductWastageReportData);
    }
}
